import { Field, useField } from "formik";
import React, { FC } from "react";
import { FeedbackMessage } from "./FeedbackMessage";

interface IShuffleRadioButtonType {
  name: string;
  disabled?: boolean;
  changeFn: () => void;
  value: any;
}

export const InputRandom: FC<IShuffleRadioButtonType> = ({
  changeFn,
  name,
  disabled,
  value,
}) => {
  const [field, meta, helpers] = useField(name);

  return (
    <>
      <Field isInvalid={meta.touched && meta.error} name={name}>
        {() => (
          <div
            style={disabled ? { pointerEvents: "none", opacity: '0.65' } : {}}
            onClick={() => {
              helpers.setValue(
                field.value === "RANDOM" ? "CONSTANT" : "RANDOM"
              );
              changeFn();
            }}
          >
            {value === "RANDOM" ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </div>
        )}
      </Field>
      <FeedbackMessage fieldId={name} />
    </>
  );
};
